import emberSwal from "ui-kit/utils/ember-swal";
export default async function wiseSwalIgnoreAndConfirm(title, body, onConfirm, onCancel) {
  emberSwal.fire({
    title: `<div class='font-bold text-h3 text-pink'>${title}</div>`,
    html: `<div class='text-left flex gap-4 flex-col'>${body}</div>`,
    cancelButtonText: "Confirmer",
    cancelButtonColor: "#fc1369",
    showCancelButton: true,
    confirmButtonText: "Ignorer",
    confirmButtonColor: "#888888",
    width: 600
  }).then(async result => {
    // We reverse the action, as the cancel button is on the right
    if (result.isConfirmed) {
      await onCancel?.();
    } else {
      await onConfirm?.();
    }
  });
}
export async function wiseSwalContinue(title, body, onContinue) {
  emberSwal.fire({
    title: `<div class='font-bold text-h3 text-pink'>${title}</div>`,
    html: `<div class='text-left flex gap-4 flex-col'>${body}</div>`,
    showCancelButton: false,
    confirmButtonText: "Ignorer",
    confirmButtonColor: "#888888",
    width: 600
  }).then(async result => {
    if (result.isConfirmed) {
      await onContinue?.();
    }
  });
}